import React from 'react';
import { Col, Row } from 'antd';
import { ModeBupMessageList } from '@BUP/components';
import { useTranslation } from 'react-i18next';
import styles from './mode-bup-panel.module.css';

const ModeBupPanel = ({ title }) => {
  const [t] = useTranslation();
  return (
    <div>
      <Row>
        <Col>
          <h3 className={styles.container_title}>{title}</h3>
        </Col>
      </Row>
      <Row className={styles.container} type="flex" align="middle">
        <Col span={24}>
          <h4 className={styles.card_title}>{t('pages.home.lastMessages')}</h4>
        </Col>
        <Col span={24}>
          <ModeBupMessageList />
        </Col>
      </Row>
    </div>
  );
};

export default ModeBupPanel;
